module.exports = {"settings":{"center":[-36.935416,144.942467],"zoomMobile":"6","zoomDesktop":"7","maxZoom":17,"initialZoom":7,"minZoomDesktop":7,"minZoomMobile":6},"defaultBaseMap":{"display_name":"Vicmap Greyscale","short_name":"vicmap_greyscale","uri":"https://mapscape.maps.em.vic.gov.au/greyscale/{z}/{x}/{y}.png","params":{"minZoomDesktop":7,"minZoomMobile":6,"attribution":"Vicmap Book by Spatial Vision Greyscale","id":"","accessToken":""}}}


//////////////////
// WEBPACK FOOTER
// ./src/config/map_settings.json
// module id = 239
// module chunks = 0